import LoginForm from "../components/login/login-form";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import LogoComponent from "../components/logo-comp";
// import BrandButton from "../components/brand-button";

const ThankYouPage = () => {
    const { t, i18n } = useTranslation();
    // const publicUrl = process.env.PUBLIC_URL;
    // const homeLbl = i18n.exists("pages.homeLbl") ? t('pages.homeLbl') : "Начало";
    // const yourOrderLbl = i18n.exists("pages.yourOrderLbl") ? t('pages.yourOrderLbl') : "Your order is on its way";
    const thankyouLbl = i18n.exists("pages.thankyouLbl") ? t('pages.thankyouLbl') : "Благодарим за направената поръчка";

    return (
        <div className="pg-form checkout-page flex-box thank-you">
            {/* <div className="mobile-top"></div> */}
            {/* <div className="checkout-bg"></div> */}
            <div className="checkout-main">
                <div className='thank-you-in'>
                    <LogoComponent logoColor="white" />
                    <h1>
                        {thankyouLbl}
                    </h1>
                    {/* <img src={`${publicUrl}/img/check-mark.png`} alt="checkmark" className="img-responsive" /> */}
                    {/* <div>
                        <p>{yourOrderLbl}...</p>
                    </div>
                    <div className="align-center">
                        <BrandButton text={homeLbl} href='/' title={homeLbl} backgroundColor="#fff" classNameAttr="capitalize"/>
                    </div> */}
                </div>
            </div>
            {/* <div className="right-bg"></div> */}
            {/* <div className="mobile-bottom"></div> */}
        </div>
    )
}

export default ThankYouPage;